<template>
  <div class="time-pattern-container">
    <div class="time" :class="{ 'disable-pause': !allowPause }">
      <div class="time-container">
        <img class="clock" src="@/assets/images/exam/clock@3x.png" />
        <span class="part">{{ time_hours }}</span>
        <span class="semi">:</span>
        <span class="part">{{ time_minutes }}</span>
        <span class="semi">:</span>
        <span class="part">{{ time_seconds }}</span>
      </div>
      <span v-if="allowPause" class="control" @click="isPause = !isPause">
        暂停
      </span>

      <el-dialog
        class="dialog-pause"
        title="提示"
        :visible.sync="isPause"
        append-to-body
        width="576px"
      >
        <div class="title">休息一下</div>
        <div class="answer-info">
          <span>已作答</span>
          <span class="primary-color">{{ count }}</span>
          <span>道题，已用时</span>
          <span class="primary-color" v-if="realTimeParts.hours != '00'">
            {{ realTimeParts.hours }}小时
          </span>
          <span class="primary-color">{{ realTimeParts.minutes }}分钟</span>
        </div>
        <template v-slot:footer>
          <el-button type="primary" @click="isPause = false">
            继续本次作答
          </el-button>
        </template>
      </el-dialog>
    </div>

    <el-dropdown
      @command="handleCommand"
      trigger="click"
      v-if="
        !hideSetting &&
        $store.state.questionMode &&
        $store.state.questionMode.split(',').length > 1
      "
    >
      <div class="el-dropdown-link set-pattern"></div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          command="2"
          class="dropdown-item"
          :class="{ active: $store.state.questionModeSelect == 2 }"
        >
          练习模式
        </el-dropdown-item>
        <el-dropdown-item
          command="1"
          class="dropdown-item"
          :class="{ active: $store.state.questionModeSelect == 1 }"
        >
          考试模式{{ $store.questionModeSelect }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  name: "Timer",
  props: {
    //是否是考试
    testModel: {
      type: Boolean,
      default: false,
    },
    hideSetting: {
      type: Boolean,
      default: false,
    },
    initValue: {
      type: Number,
      default: 0,
    },
    limitTime: {
      type: Number,
      default: 0,
    },
    reportId: {},
    count: {
      type: Number,
      default: 0,
    },
    endTime: {
      type: Number,
      default: 0,
    },
    allowPause: {
      type: Boolean,
      default: true,
    },
    storeKey: {
      type: String,
      default: "exam-seconds",
    },
  },
  data() {
    return {
      seconds: 0,
      timer: null,
      time_hours: "00",
      time_minutes: "00",
      time_seconds: "00",
      isPause: false,
      isStop: false,
    };
  },
  computed: {
    realTimeParts() {
      return this.getTimePart(this.seconds);
    },
  },
  methods: {
    handleCommand(command) {
      if (this.$store.state.questionModeSelect == command) return;
      this.$http.post("/api/app/practise/storeReportMode", {
        report_id: this.$route.query.id,
        mode: command,
      });

      this.$store.commit("setQuestionModeSelect", command);
      this.$store.commit("setShowQuestionAnswer", {
        is_confirm: this.$store.state["showQuestionAnswer"].is_confirm,
        get: true,
      });
    },
    getTimePart(seconds) {
      let hours = parseInt(seconds / 60 / 60);
      hours = hours < 10 ? "0" + hours.toString() : hours.toString();
      let minutes = parseInt((seconds / 60) % 60);
      minutes = minutes < 10 ? "0" + minutes.toString() : minutes.toString();
      let surplus_seconds = seconds % 60;
      surplus_seconds =
        surplus_seconds < 10
          ? "0" + surplus_seconds.toString()
          : surplus_seconds.toString();
      return { hours, minutes, seconds: surplus_seconds };
    },
    formatTime() {
      let seconds = this.seconds;
      if (this.limitTime > 0) {
        seconds = this.limitTime - seconds;
      }
      let parts = this.getTimePart(seconds);
      this.time_hours = parts.hours;
      this.time_minutes = parts.minutes;
      this.time_seconds = parts.seconds;
    },
    start() {
      this.$nextTick(() => {
        if (this.endTime) {
          this.seconds = this.endTime - parseInt(new Date().getTime() / 1000);
        } else {
          this.seconds = this.initValue;
        }
        this.timer = setInterval(() => {
          if (this.isPause || this.isStop) {
            return;
          }
          if (this.endTime) {
            this.seconds--;
          } else {
            this.seconds++;
          }

          if (!this.endTime) {
            let store = this.$storage().get(this.storeKey) || {};
            store[this.reportId] = this.seconds;
            this.$storage().set(this.storeKey, store);
          }

          this.formatTime();

          this.$emit("update", this.seconds);
          let isEnd = false;
          if (this.endTime) {
            if (this.seconds <= 0) {
              isEnd = true;
            }
          } else if (this.limitTime > 0 && this.limitTime - this.seconds <= 0) {
            isEnd = true;
          }
          if (isEnd) {
            clearInterval(this.timer);
            this.$emit("submit", true);
          }
        }, 1000);
      });
    },
    pause() {
      this.isPause = true;
    },
    stop() {
      this.isStop = true;
    },
    continue() {
      this.isStop = false;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.time-pattern-container {
  display: flex;
}

.time {
  flex: 1;
  height: 36px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    border-color: $primary-color;
  }

  .time-container {
    display: flex;
    align-items: center;

    .clock {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      margin-left: 13px;
    }

    .part {
      width: 24px;
      height: 24px;
      background: #4d4d4d;
      border-radius: 1px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 24px;
    }

    .semi {
      width: 3px;
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      margin: 0 3px;
    }
  }
  .text {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 1;
    margin-right: 9px;
  }
  &.disable-pause {
    .text {
      margin-right: 82px;
    }
  }
  .control {
    margin-left: 24px;
    padding-right: 12px;
    cursor: pointer;
    background-image: url("~@/assets/images/exam/pause@2x.png");
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 8px 12px;
    color: #343434;
    padding-left: 15px;
    font-size: 14px;

    &:hover {
      background-image: url("~@/assets/images/exam/pause-checked@2x.png");
      color: $primary-color;
    }
  }
  .pause {
    width: 8px;
    height: 12px;
    margin-right: 7px;
  }
  .status {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
  }
}

.set-pattern {
  cursor: pointer;
  box-sizing: border-box;
  margin-left: 8px;
  width: 36px;
  height: 36px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background: url("~@/assets/images/exam/frame-143@2x.png") no-repeat center;
  background-size: 20px 20px;
}

.el-dropdown-menu {
  top: 168px !important;

  .dropdown-item {
    width: 120px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: JUSTIFIED;
    color: #333333;

    &:hover {
      background-color: #ffeee9;
      font-weight: 600;
      color: #fd784f;
    }
  }

  .active {
    // background-color: #ffeee9;
    font-weight: 600;
    color: #fd784f;
  }
}

.dialog-pause {
  text-align: center;
  /deep/ {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      overflow: visible;
    }
    .title {
      padding: 37px 0 16px 0;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
    }
    .answer-info {
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
    }
    .primary-color {
      margin: 0 6px;
    }
    .el-dialog__footer {
      padding: 42px 0 20px 0;
      text-align: center;
    }
  }
}
</style>
